import { useEffect, useRef, useState } from "react";

import { useCreateScriptTag } from "../../utils/useCreateScriptTag";

import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import { faChevronCircleRight } from "@fortawesome/pro-light-svg-icons";

function useCloverScript(useSandbox = true) {
	const src = useSandbox
		? "https://checkout.sandbox.dev.clover.com/sdk.js"
		: "https://checkout.clover.com/sdk.js";

	const status = useCreateScriptTag(src);

	return status;
}

/* 
	thc = 49S89N3SNQWJ1 / f29465a2f56dffa181b4560b9bdd9df6
	sandbox = MMXBEA1QQJBS1 / 430175be73aeb23e905db1c4e3930b11
	old chc = 0AW6F4BRB2B41 / a1d7ef71901200f7b8c8ed307c25f4cc

	clover test cards for sandbox
		4242 4242 4242 4242 - success
		4005 5717 0222 2222 - decline
*/

const MERCHANT_PUBLIC_KEY = "f29465a2f56dffa181b4560b9bdd9df6";
const MERCHANT_ID = "49S89N3SNQWJ1";
const MERCHANT_SANDBOX = false; // sandbox = true

export default function PaymentCloverForm({ handleToken }) {
	const [errorMsg, setErrorMsg] = useState("");
	const [working, setWorking] = useState(false);

	const status = useCloverScript(MERCHANT_SANDBOX); // true = sandbox
	const formRef = useRef(null);
	const elementsRef = useRef(null);

	useEffect(() => {
		if (status === "ready" && window.Clover && formRef.current) {
			// Create Clover instance
			const clover = new window.Clover(MERCHANT_PUBLIC_KEY, {
				merchantId: MERCHANT_ID,
			});
			const elements = clover.elements();
			elementsRef.current = { clover, elements };

			// Mount card fields into designated divs
			const fields = [
				{ type: "CARD_NUMBER", id: "card-number" },
				{ type: "CARD_NAME", id: "card-name" },
				{ type: "CARD_DATE", id: "card-date" },
				{ type: "CARD_CVV", id: "card-cvv" },
				{ type: "CARD_STREET_ADDRESS", id: "card-street-address" },
				{ type: "CARD_POSTAL_CODE", id: "card-postal-code" },
			];

			const styles = {
				/*input: {
					margin: "0",
					fontSize: "16px",
					border: "1px solid #ddd",
					padding: "15px 7.5px",
					width: "50%",
				},*/
				input: {
					margin: "0",
					width: "100%",
					border: "1px solid #ddd",
					borderRadius: "4px",
					verticalAlign: "middle",
					padding: "15px 7.5px",
					fontFamily: "Helvetica, Arial, sans-serif",
					fontSize: "16px",
					outline: "none",
					boxShadow: "0 1px 3px 0 e6ebf1",
					"-webkit-transition": "box-shadow 150ms ease",
					transition: "box-shadow 150ms ease",
					appearance: "none",
				},
				"input::placeholder": {
					color: "#fff", // placeholder color
				},
			};

			fields.forEach(({ type, id }) => {
				const el = elements.create(
					type,
					id === "card-number"
						? {
								...styles,
								input: { ...styles.input, width: "calc(50% - 7.5px)" },
						  }
						: { ...styles },
				);
				el.mount(`#${id}`);
			});
		}
	}, [status]);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrorMsg("");
		setWorking(true);

		const { clover } = elementsRef.current || {};
		if (!clover) return;

		try {
			const result = await clover.createToken();
			if (result.errors) {
				setErrorMsg(Object.values(result.errors).join("; "));
				setWorking(false);
			} else {
				handleToken(result.token);
			}
		} catch (err) {
			setErrorMsg(err.message);
			setWorking(false);
		}
	};

	return (
		<form ref={formRef} onSubmit={handleSubmit} id="payment-form">
			<div className="element">
				<label>
					Credit or Debit Card Number{" "}
					<span style={{ color: "var(--error)" }}>*</span>
				</label>
				<div id="card-number"></div>
			</div>

			<div className="three">
				<div className="element">
					<label>
						Cardholder Name <span style={{ color: "var(--error)" }}>*</span>
					</label>
					<div id="card-name"></div>
				</div>

				<div className="element">
					<label>
						Expiration Date (mm/yy){" "}
						<span style={{ color: "var(--error)" }}>*</span>
					</label>
					<div id="card-date"></div>
				</div>

				<div className="element">
					<label>
						CVV/CID Code <span style={{ color: "var(--error)" }}>*</span>
					</label>
					<div id="card-cvv"></div>
				</div>
			</div>

			<div className="two">
				<div className="element">
					<label>
						Billing Street Address{" "}
						<span style={{ color: "var(--error)" }}>*</span>
					</label>
					<div id="card-street-address"></div>
				</div>

				<div className="element">
					<label>
						Billing Zip Code <span style={{ color: "var(--error)" }}>*</span>
					</label>
					<div id="card-postal-code"></div>
				</div>
			</div>

			<div className="msg-submit">
				{errorMsg && <Msg data={{ type: "error", text: errorMsg }} />}

				{/* hidden not working here*/}
				<div
					className={
						status !== "ready" || working
							? "submit-container"
							: "submit-container"
					}
				>
					<Submit
						name="Submit Payment"
						icon={faChevronCircleRight}
						cares={true}
					/>
				</div>
			</div>
		</form>
	);
}
